{
  "title": "Statistik",
  "empty_state": "Din progressstatistik visas här.",
  "backend_pending": "Backend saknas",
  "metrics_error_title": "Statistik är inte tillgänglig",
  "metrics_error_message": "Vi kunde inte ladda din statistik. Kontrollera din anslutning och försök igen.",
  "metric_warmups_title": "Uppvärmning",
  "metric_time_title": "Tid",
  "metric_exercises_title": "Övningar",
  "metric_total_title": "Totalt",
  "metric_current_streak_title": "Nuvarande streak",
  "metric_best_streak_title": "Bästa streak",
  "metric_warmups_value_completed": "{{count}} slutförda",
  "metric_time_value_minutes_one": "{{count}} min",
  "metric_time_value_minutes_other": "{{count}} min",
  "metric_time_value_hours_one": "{{count}} timme",
  "metric_time_value_hours_other": "{{count}} timmar",
  "metric_time_value_days_one": "{{count}} dag",
  "metric_time_value_days_other": "{{count}} dagar",
  "metric_exercises_value_completed": "{{count}} slutförda",
  "timeframe_this_week": "Denna vecka",
  "timeframe_since_start": "Sedan start",
  "timeframe_activity_goal_reached": "Aktivitetsmål uppnått",
  "timeframe_past_30_days": "Senaste 30 dagarna",
  "exercise_goal_label": "Träningsmål",
  "exercise_goal_value_per_week_one": "{{count}} övning per vecka",
  "exercise_goal_value_per_week_other": "{{count}} övningar per vecka",
  "exercise_goal_modal_title": "Hur många gånger i veckan vill du träna?",
  "exercise_goal_update_failed": "Det gick inte att uppdatera träningsmålet.",
  "week_unit_one": "vecka",
  "week_unit_other": "veckor",
  "exercise_unit_one": "övning",
  "exercise_unit_other": "övningar",
  "voice_assessment_section_title": "Senaste röstmätning",
  "voice_assessment_microphone_accessibility": "Röstmätning",
  "voice_assessment_history_link": "Historik",
  "voice_assessment_empty_title": "Inga mätningar",
  "voice_assessment_empty_subtitle": "Du har en väntande röstmätning att göra.",
  "voice_assessment_error_title": "Röstmätningen är inte tillgänglig",
  "voice_assessment_error_message": "Vi kunde inte ladda din senaste röstmätning. Försök igen, eller fortsätt med dina andra övningar.",
  "voice_assessment_placeholder_dash": "–",
  "voice_assessment_start_button": "Starta mätning",
  "voice_assessment_analyzing_title": "Analyserar senaste röstmätning",
  "voice_assessment_analysis_ready_title": "Analys klar",
  "voice_assessment_analysis_ready_message": "Resultaten från din senaste röstmätning finns nu.",
  "voice_assessment_analysis_failed_title": "Analys misslyckades",
  "voice_assessment_analysis_failed_message": "Vi kunde inte analysera din senaste röstmätning. Försök igen.",
  "voice_assessment_history_row_analyzing": "Analyserar",
  "voice_assessment_voice_feeling_label": "Röstkänsla",
  "voice_assessment_mental_state_label": "Mental status",
  "voice_assessment_measurement_title": "Mätning {{n}}",
  "voice_assessment_question_title": "Fråga {{n}}",
  "voice_assessment_metric_voice_freedom": "Röstfrihet",
  "voice_assessment_metric_ease_of_exercise": "Lätthet i övning",
  "voice_assessment_metric_tension": "Spänning",
  "voice_assessment_metric_tension_placement": "Var spänning sitter",
  "voice_assessment_reflection_label": "Personlig reflektion",
  "voice_assessment_rating_out_of": "{{rating}}/{{max}}",
  "voice_assessment_history_screen_title": "Historik röstmätningar",
  "voice_assessment_details_screen_title": "Röstmätning — detaljer",
  "voice_assessment_voice_context_section_title": "Röstkontext",
  "voice_assessment_singing_score_label": "Sångpoäng",
  "voice_assessment_comfortable_range_label": "Bekvämt röstomfång",
  "voice_assessment_pitch_range_label": "Totalt röstomfång",
  "voice_assessment_recording_label": "Inspelning",
  "voice_assessment_recording_loading": "Laddar inspelning…",
  "voice_assessment_recording_error_title": "Inspelningen är inte tillgänglig",
  "voice_assessment_recording_error_message": "Vi kunde inte ladda ljudet just nu.",
  "voice_assessment_recording_retry_button": "Försök igen",
  "voice_assessment_latest_title": "Senaste röstmätning",
  "voice_assessment_history_exercise_count_one": "{{count}} mätning",
  "voice_assessment_history_exercise_count_other": "{{count}} mätningar",
  "voice_assessment_history_row_error_title": "Mätningen är inte tillgänglig",
  "voice_assessment_history_row_error_message": "Vi kunde inte ladda den här mätningen. Kontrollera din anslutning och försök igen.",
  "voice_assessment_aborted_title": "Analys avbruten",
  "voice_assessment_not_analyzed_title": "Ej analyserad",
  "voice_assessment_stats_pending_body": "Din mätning är sparad. Detaljerad statistik visas här när den finns tillgänglig.",
  "voice_assessment_retry_button": "Försök igen",
  "voice_assessment_history_entry_heading": "{{date}}",
  "voice_assessment_mental_state_tired": "Trött",
  "voice_assessment_mental_state_focused": "Fokuserad",
  "voice_assessment_tension_placement_jaw_tongue": "Käke/tunga",
  "voice_assessment_tension_placement_neck_shoulders": "Nacke/axlar",
  "voice_assessment_statistics_current_label": "Nuvarande",
  "voice_assessment_segment_weekly": "Vecka",
  "voice_assessment_segment_monthly": "Månad",
  "voice_assessment_segment_six_months": "6 månader",
  "voice_assessment_segment_all": "Allt",
  "voice_assessment_segment_yearly": "År",
  "voice_assessment_range_section_title": "Omfång",
  "voice_assessment_range_current_heading": "Nuvarande",
  "voice_assessment_range_historic_heading": "Historik",
  "voice_assessment_chart_note_a4": "A4",
  "voice_assessment_chart_note_b4": "B4",
  "voice_assessment_chart_note_c5": "C5",
  "voice_assessment_chart_note_d5": "D5",
  "voice_assessment_chart_note_e5": "E5",
  "voice_assessment_chart_note_f5": "F5",
  "voice_assessment_chart_note_g5": "G5",
  "voice_assessment_chart_month_jan": "jan",
  "voice_assessment_chart_month_feb": "feb",
  "voice_assessment_chart_month_mar": "mar",
  "voice_assessment_chart_month_apr": "apr",
  "voice_assessment_chart_month_may": "maj",
  "voice_assessment_chart_month_jun": "jun",
  "voice_assessment_chart_month_jul": "jul",
  "voice_assessment_chart_month_aug": "aug",
  "voice_assessment_chart_month_sep": "sep",
  "voice_assessment_chart_month_oct": "okt",
  "voice_assessment_chart_month_nov": "nov",
  "voice_assessment_chart_month_dec": "dec",
  "voice_type_section_title": "Rösttyp",
  "voice_type_soprano": "Sopran",
  "voice_type_alto": "Alt",
  "voice_type_tenor": "Tenor",
  "voice_type_bass": "Bas",
  "voice_type_baritone": "Baritone",
  "voice_type_mezzoSoprano": "Mezzo-Soprano"
}
